import React from "react";
import PropTypes from 'prop-types';

export const saveToLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getFromLocalStorage = key => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const TabButton = ({ label, value, tabSelected, setTabSelected }) => {
  const isActive = tabSelected === value;

  const styles = {
    padding: '1rem 2rem',
    borderRadius: '6px 6px 0 0',
    background: isActive ? '#4b286d' : '#ffffff',
    border: isActive ? '2px solid #4b286d' : '1px solid #e4e4e4',
    borderBottom: 0,
    color: isActive ? '#ffffff' : '#454545',
    fontWeight: isActive ? '800' : '500',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
  };

  return (
    <li>
      <button
        type="button"
        onClick={() => setTabSelected(value)}
        style={styles}
      >
        {label}
      </button>
    </li>
  );
};

TabButton.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  tabSelected: PropTypes.string.isRequired,
  setTabSelected: PropTypes.func.isRequired,
};

